import React, { useState, useEffect, useContext } from "react";
import {
  genOTPandSavePwd,
  selectOTPandPwdDetails,
} from "./genOTPandSavePwdSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string, InferType } from "yup";
import { useForm } from "react-hook-form";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN } from "../../../../utils/CONSTANTS";
import "./otpVerification.scss";
import CountDownTimer from "./otpCountDownTimer";
import { nonSSOLogin, selectNonSSOLoginDetails } from "./nonSSOLoginSlice";
import AuthContext from "../../shared-components/authContext";
import {
  genOTPandSaveUser,
  selectOTPandUserDetails,
} from "./genOTPandSaveUserSlice";
import { registerUser, selectUserDetails } from "./registerUserSlice";
import DotGlobe from "./DotGlobe";
import { OtpInput } from "./OtpInput";

export function OTPVerification(props: any) {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, state, requestType, message } = useSelector(
    selectOTPandPwdDetails
  );
  const {
    nonSSOStatus,
    nonSSOState,
    nonSSOReqType,
    accesstoken,
    refreshtoken,
    isRehire,
  } = useSelector(selectNonSSOLoginDetails);
  const [otp, setOtp] = useState("");
  const { otpstate, otpstatus, regrequestType } = useSelector(
    selectOTPandUserDetails
  );
  const { regStatus, regState, userRequestType } =
    useSelector(selectUserDetails);
  const [userRegStatus, setUserRegStatus] = useState(regStatus);
  const [isResendClicked, setisResendClicked] = useState(false);
  const { login } = useContext(AuthContext);
  const buffer = require("buffer/").Buffer;

  const otpSchema = object({
    otp: string()
      .required("Please enter the OTP")
      .min(6, "OTP minimum digit is 6")
      .max(6, "OTP maximum digit is 6"),
  });

  type otpProps = InferType<typeof otpSchema>;

  const {
    register: otpRegister,
    handleSubmit: otpHandle,
    formState: { errors: otpErrors },
    reset: otpReset,
    setValue: otpSetValue,
  } = useForm<otpProps>({
    resolver: yupResolver(otpSchema),
  });

  // Register the OTP field once so the segmented OtpInput can drive it via setValue
  // (no visible native input needed). Validation/schema unchanged.
  useEffect(() => {
    otpRegister("otp");
  }, [otpRegister]);

  const handleOtpChange = (value: string) => {
    setOtp(value);
    otpSetValue("otp", value, { shouldValidate: false });
  };

  function handleSubmitOTP() {
    setisResendClicked(false);
    if (requestType === "genOtp" || requestType === "savePwd") {
      const data = {
        input: {
          employeeUid: buffer.from(params.id, "base64").toString("ascii"),
          password: props.details.pwd,
          otpNumber: otp,
          action: "ResetPassword",
          subAction: "reset",
          linkUid: params.token,
        },
        requestType: {
          type: "savePwd",
        },
      };
      dispatch<any>(genOTPandSavePwd(data));
    }

    if (
      props !== undefined &&
      props !== null &&
      (props.details?.type === "login" || props.details?.type === "validate")
    ) {
      const data = {
        input: {
          username: props.details.mail,
          password: "",
          otp: otp,
          subAction: props.details.type,
        },
        nonSSOReqType: {
          type: "validate",
        },
      };
      dispatch<any>(nonSSOLogin(data));
    }

    if (regrequestType === "genOtp") {
      const data = {
        employeeUid: props.details.emp_uid,
        otpNumber: otp,
        password: props.details.pwd,
        action: "RegisterUser",
      };
      dispatch<any>(registerUser(data));
    }
    setUserRegStatus(regStatus);
  }

  function handleResendOTP() {
    setisResendClicked(true);
    let phoneNo = "";
    let mail = "";
    let empType = "";
    let type = "";

    if (regrequestType === "genOtp") {
      mail = props.details.email;
      phoneNo = props.details.phoneNumber;
      empType = "SignUp";
      type = "genOtp";
    }

    if (requestType === "genOtp" || requestType === "savePwd") {
      mail = buffer.from(params.email, "base64").toString("ascii");
      phoneNo = "";
      empType = "";
      type = "reset";
    }

    if (
      props !== undefined &&
      props !== null &&
      props.details?.type === "login"
    ) {
      mail = props.details.mail;
      phoneNo = "";
      empType = "";
      type = "login";
    }

    const data = {
      input: {
        request: {
          action: "ValidateNewUser",
          personalEmailAddress: mail,
          phoneNumber: phoneNo,
          subAction: empType,
        },
      },
      requestType: {
        type: type,
      },
    };
    dispatch<any>(genOTPandSaveUser(data));
    if (regrequestType === "genOtp") {
      otpReset();
      setUserRegStatus(null);
    }
  }

  useEffect(() => {
    if (
      nonSSOState === "fulfilled" &&
      nonSSOStatus === "success" &&
      nonSSOReqType === "validate"
    ) {
      const data = {
        accessToken: accesstoken,
        refreshToken: refreshtoken,
      };
      login(data);
    }
  }, [
    nonSSOState,
    nonSSOStatus,
    nonSSOReqType,
    accesstoken,
    refreshtoken,
    login,
  ]);

  useEffect(() => {
    setUserRegStatus(regStatus);
  }, [regStatus]);

  useEffect(() => {
    if (otpstate !== "" && otpstate !== "pending") {
      setisResendClicked(false);
    }
  }, [otpstate]);

  function refreshPage() {
    navigate(LOGIN);
    window.location.reload();
  }

  const BackArrow = (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M15 6l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="landingPage">
      <aside className="brandPanel" aria-hidden="true">
        <div className="brandGrid" />
        <DotGlobe className="brandGlobe" size={520} variant="bright" />
        <div className="brandPanelContent">
          <h2 className="brandTitle">TTEC Connect</h2>
          <p className="brandTagline">
            Everything you need to get started — your onboarding hub, in one
            place.
          </p>
        </div>
      </aside>
      <div className="loginContainer">
        <form className="Auth-form">
          {((requestType === "genOtp" &&
            (state === "fulfilled" || status === "200")) ||
            (requestType === "savePwd" &&
              (state === "pending" || status === "400")) ||
            (props !== undefined &&
              props !== null &&
              props.details.type === "login") ||
            nonSSOReqType === "validate" ||
            (regStatus !== "200" &&
              (otpstatus === "200" || otpstatus === "400") &&
              regrequestType === "genOtp")) && (
            <div>
              <div className="stepper">
                <div className="st done">
                  <span className="dot">✓</span>Account
                </div>
                <span className="bar"></span>
                <div className="st active">
                  <span className="dot">2</span>Verify
                </div>
              </div>
              <h1 className="authH1">Enter verification code</h1>
              <p className="sub">
                We sent a 6-digit code to your mobile and email.
              </p>

              {isRehire && (
                <div className="alert ok" role="status">
                  Welcome back to TTEC 👋 Your account has been reactivated. Sign
                  in with your personal email until your start date, then switch
                  to the Current Employee (SSO) option.
                </div>
              )}

              {!isResendClicked &&
                (nonSSOState !== "pending" ||
                  otpstate !== "pending" ||
                  state !== "pending") && (
                  <div className="alert ok">
                    A One Time Password (OTP) has been sent to your mobile number
                    and email address.
                  </div>
                )}

              <OtpInput value={otp} onChange={handleOtpChange} />

              <p className="frmErrors mt-2">
                {(((requestType === "savePwd" &&
                  (state === "failed" || status === "400")) ||
                  (nonSSOStatus === "fail" && nonSSOState !== "pending") ||
                  (userRegStatus === "400" && regState !== "pending")) &&
                  (message || "Please enter correct OTP")) ||
                  (otpErrors?.otp && otpErrors?.otp?.message)}
              </p>

              {!isResendClicked && otpstate !== "pending" && (
                <div className="timerRow">
                  <CountDownTimer hours={0} minutes={10} seconds={0o0} />
                </div>
              )}
              {!isResendClicked && otpstate !== "pending" && (
                <div className="resendRow">
                  Didn't receive the code? &nbsp;
                  <Link to="" onClick={handleResendOTP}>
                    Resend Code
                  </Link>
                </div>
              )}
              {isResendClicked && otpstate === "pending" && (
                <div className="resendRow">
                  Resending Code... &nbsp; <div className="counter"></div>
                </div>
              )}

              <button
                type="button"
                onClick={otpHandle(handleSubmitOTP)}
                className="btn btn-primary"
                style={{ marginTop: "6px" }}
              >
                Verify OTP
              </button>
            </div>
          )}

          {userRequestType === "saveUser" &&
            regStatus === "200" &&
            regState === "fulfilled" && (
              <div className="center">
                <div className="successMark">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h1 className="authH1">Welcome to TTEC</h1>
                <div className="alert ok">
                  You have registered successfully. You can now login with your
                  registered email and password.
                </div>
                <Link to="" className="backlink" onClick={refreshPage}>
                  {BackArrow}
                  Back to Sign In
                </Link>
              </div>
            )}

          {nonSSOReqType !== "login" &&
            requestType === "savePwd" &&
            status === "200" &&
            state === "fulfilled" && (
              <div className="center">
                <div className="successMark">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h1 className="authH1">Password reset</h1>
                <div className="alert ok">
                  Your password has been reset successfully. You can now login
                  with your new password.
                </div>
                <Link to="" className="backlink" onClick={refreshPage}>
                  {BackArrow}
                  Back to Sign In
                </Link>
              </div>
            )}
        </form>
      </div>
    </div>
  );
}
